import { apiSlice } from "../../app/api/apiSlice";

export const lockExtensionSubmitRequestApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		lockExtensionSubmitRequest: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loan/create_ob_lock_extension_submit_request/",
				method: "POST",
				body: body,
			}),
		}),
	}),
});

export const { useLockExtensionSubmitRequestMutation } = lockExtensionSubmitRequestApiSlice;

